import React from "react";
import { ExitToAppOutlined } from "@mui/icons-material";
import { caseConstants } from "@_constants/case.constants";
import CardShell from "../core/CardShell";

// ── Content map ───────────────────────────────────────────────────────────────

const CONTENT_MAP = {
  [caseConstants.CASEACTIVITY_TYPE_LINK_CLICKED]:
    "The website owner visited the settlement portal",
  [caseConstants.CASEACTIVITY_TYPE_LOGIN]:
    "The website owner logged into the settlement portal",
  [caseConstants.CASEACTIVITY_TYPE_BILLING_ADDR_SET]:
    "The website owner has started the checkout process",
};

const TYPE_LABELS = {
  [caseConstants.CASEACTIVITY_TYPE_LINK_CLICKED]: "Portal Visit",
  [caseConstants.CASEACTIVITY_TYPE_LOGIN]: "Portal Login",
  [caseConstants.CASEACTIVITY_TYPE_BILLING_ADDR_SET]: "Checkout initiated",
};

// ── Component ─────────────────────────────────────────────────────────────────

/**
 * WebsiteOwnerActivityCard
 *
 * Handles the three "website owner portal" event types:
 *   - LINK_CLICKED (portal visit)
 *   - LOGIN
 *   - BILLING_ADDR_SET (checkout started)
 *
 * All three are read-only, non-expandable rows.
 */
export default function WebsiteOwnerActivityCard({ activity }) {
  return (
    <CardShell
      activity={activity}
      icon={<ExitToAppOutlined />}
      typeText={TYPE_LABELS[activity.type]}
      typeSubText={activity.user_name}
      contentPreview={<>{CONTENT_MAP[activity.type]}</>}
    />
  );
}
